import * as A from '@/domain/categories/actions';
import { CategoriesStoreFactory } from '@/domain/categories/adapters';

import * as documentsActions from '@/domain/documents/documentsActions';

export const reducer = {
  categories(state = CategoriesStoreFactory(), action) {
    switch (action.type) {
      case A.getCategoriesAction.type:
        return state;

      case documentsActions.moveAllCategoryDocumentsToOtherCategoryAction.success:
      case documentsActions.moveDocumentToCategoryAction.success:
      case A.getCategoriesAction.success: {
        return state.setIn(['list'], action.payload.list);
      }

      default:
        return state;
    }
  },
};
